<template>
  <div class="participant-status">
    <div class="right">
      <emoji-circle
        :emoji="participant.challengeData.emoji"
        :color="participant.challengeData.color"
      />
      <div class="firstName ri-body">
        {{ firstName }}
      </div>
    </div>
    <div class="left ri-bold-body">
      <animated-number :value="amount" /> ₪
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { Participant } from '../../types/challenge';
import EmojiCircle from './EmojiCircle.vue';

interface Props {
  participant: Participant;
}
const props = defineProps<Props>();

const firstName = computed(() => (props.participant?.isMe ? `${props.participant?.firstName} (אני)` : props.participant?.firstName));
const amount = computed<number>(() => props.participant?.challengeData?.expenseAmount || 0);

</script>

<style lang="scss" scoped>
@import 'base-ui-vue3/src/scss/riseup-colors';

.participant-status {
  display: flex;
  justify-content: space-between;

  .right {
    display: flex;
    align-items: center;
    padding: 24px 0;
    .firstName {
      margin-right: 16px;
    }
  }
  .left {
    display: flex;
    align-items: center;
    color: $riseup_blue;
  }
}
</style>
